// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const TracingOut = zod.object({
  "active": zod.boolean(),
  "enabled_by": zod.union([zod.string(),zod.null()]).optional(),
  "max_hours": zod.int(),
  "reason": zod.union([zod.string(),zod.null()]).optional(),
  "remaining_seconds": zod.union([zod.int(),zod.null()]).optional(),
  "started_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).optional(),
  "until": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).optional(),
  "user": zod.union([zod.string(),zod.null()]).optional(),
  "user_id": zod.union([zod.uuid(),zod.null()]).optional()
});

export type TracingOut = zod.input<typeof TracingOut>;
export type TracingOutOutput = zod.output<typeof TracingOut>;
